import Vue from 'vue'

// initial state
const state = {
	serverUrl: '',
	staticUrl: '',
  sacrificeUrl:'',
  parkUrl:''
}

// getters
const getters = {
}

// actions
const actions = {
}

// mutations
const mutations = {
	initservel(state, data) {
		state.serverUrl = data.serverUrl
		state.staticUrl = data.staticUrl
		state.sacrificeUrl = data.sacrificeUrl
    state.parkUrl = data.parkUrl
	}
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/config.js